// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/app";
export const ROOTS_NOT_FOUND = "/404";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  signIn: path(ROOTS_AUTH, "/signin/"),
  forgetPassword: path(ROOTS_AUTH, "/forgetpassword"),
  signUp: path(ROOTS_AUTH, "/signup/"),
  transit: path(ROOTS_AUTH, "/transit/"),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  home: path(ROOTS_DASHBOARD, "/home/"),
  algorithmForm: path(ROOTS_DASHBOARD, "/form/"),
  nutrition: path(ROOTS_DASHBOARD, "/nutrition/"),
  workout: path(ROOTS_DASHBOARD, "/workout/"),
  chats: path(ROOTS_DASHBOARD, "/chats/"),
};
